import { render, staticRenderFns } from "./PackageCustomersList.vue?vue&type=template&id=0999f7c2"
import script from "./PackageCustomersList.vue?vue&type=script&lang=js"
export * from "./PackageCustomersList.vue?vue&type=script&lang=js"
import style0 from "./PackageCustomersList.vue?vue&type=style&index=0&id=0999f7c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports